export enum DocumentType {
    Other = 1,
    Invoice = 2,
    //Bill = 3,
    Awb = 4,
    InternalUseOnly = 5,
}
